import script from "./EnvironmentSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnvironmentSettings.vue?vue&type=script&setup=true&lang=ts"

import "./EnvironmentSettings.vue?vue&type=style&index=0&id=f646f1c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f646f1c4"]])

export default __exports__